import { LazyLoadImage } from 'react-lazy-load-image-component';
import { motion } from 'framer-motion';
import bgWhyBpr from '../../assets/img/whybpr.png';
import bankSvg from '../../assets/img/svg/bank.svg';
import handSvg from '../../assets/img/svg/hand.svg';
import brainSvg from '../../assets/img/svg/brain.svg';
import companySvg from '../../assets/img/svg/company.svg';
import { Link } from 'react-router-dom';

export default function WhyBpr() {
    return (
        <div className="bg-cover bg-center min-h-[868px]" style={{ backgroundImage: `url(${bgWhyBpr})` }}>
            <div className='max-w-screen-2xl mx-auto pt-16 pb-60 p-5 md:p-5 lg:p-16'>
                <motion.h1
                    className="text-[24px] font-poppinsBold text-bprDarkBlue w-full md:text-[24px] md:w-[360px]"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                >
                    MENGAPA MEMILIH BPR PALU ANUGERAH
                </motion.h1>

                <motion.div
                    className='w-full md:w-[620px] mt-10'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 1 }}
                >
                    <p className='text-xl text-textPrimary text-justify font-poppinsRegular'>
                    <b>BPR Palu Anugerah </b>memahami kebutuhan dan karakteristik masyarakat, sehingga mampu menawarkan solusi keuangan yang tepat dan sesuai. Selain itu, <b>BPR Palu Anugerah</b> telah mendapatkan izin usaha dan diawasi oleh OJK (Otoritas Jasa Keuangan), yang menjamin keamanan dan kepercayaan dalam setiap transaksi. Dengan pengawasan OJK, Anda tidak perlu khawatir tentang keamanan data pribadi dan transaksi keuangan Anda, karena kami berkomitmen untuk menjaga integritas dan kerahasiaan informasi Anda , BPR Palu Anugerah juga dijamin oleh Lembaga Penjamin Simpanan (LPS) sehingga memberikan perlindungan tambahan bagi dana Anda..
                    </p>
                </motion.div>

                <div className='mt-12 space-y-12 md:space-y-0 md:flex md:space-x-5'>
                    <motion.div
                        className='flex flex-col lg:flex-row'
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <div className='flex justify-center items-center lg:block lg:justify-start lg:items-start'>
                            <LazyLoadImage src={bankSvg} className="w-[60px]" />
                        </div>
                        <div className='space-x-3 mt-4 md:mt-0'>
                            <h3 className='text-lg font-poppinsBold text-bprDarkBlue ml-3'>Legal</h3>
                            <p className='text-textPrimary text-lg font-poppinsRegular w-full md:w-[340px] lg:w-[371px]'>
                                Diawasi langsung oleh OJK (Otoritas Jasa Keuangan), Bank BPR Palu Anugerah menjamin keamanan dan kepercayaan dalam setiap layanan keuangannya.
                            </p>
                        </div>
                    </motion.div>

                    <motion.div
                        className='flex flex-col lg:flex-row'
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <div className='flex justify-center items-center lg:block lg:justify-start lg:items-start'>
                            <LazyLoadImage src={brainSvg} className="w-[60px]" />
                        </div>
                        <div className='space-x-3 mt-4 md:mt-0'>
                            <h3 className='text-lg font-poppinsBold text-bprDarkBlue ml-3'>Terus Berinovasi</h3>
                            <p className='text-textPrimary text-lg font-poppinsRegular w-full md:w-[340px] lg:w-[371px]'>
                                Bank BPR Palu Anugerah terus berinovasi mengembangkan produk yang sesuai dengan perkembangan zaman dan kebutuhan nasabah.
                            </p>
                        </div>
                    </motion.div>
                </div>

                <div className='mt-16 space-y-12 md:space-y-0 md:flex md:space-x-5'>
                    <motion.div
                        className='flex flex-col lg:flex-row'
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <div className='flex justify-center items-center lg:block lg:justify-start lg:items-start'>
                            <LazyLoadImage src={handSvg} className="w-[60px]" />
                        </div>
                        <div className='space-x-3 mt-4 md:mt-0'>
                            <h3 className='text-lg font-poppinsBold text-bprDarkBlue ml-3'>Human Capital Kompeten</h3>
                            <p className='text-textPrimary text-lg font-poppinsRegular w-full md:w-[340px] lg:w-[371px]'>
                                Human Capital Bank BPR Palu Anugerah yang kompeten dan profesional siap melayani nasabah dengan setulus hati.
                            </p>
                        </div>
                    </motion.div>

                    <motion.div
                        className='flex flex-col lg:flex-row'
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <div className='flex justify-center items-center lg:block lg:justify-start lg:items-start'>
                            <LazyLoadImage src={companySvg} className="w-[60px]" />
                        </div>
                        <div className='space-x-3 mt-4 md:mt-0'>
                            <h3 className='text-lg font-poppinsBold text-bprDarkBlue ml-3'>Jaringan Luas</h3>
                            <p className='text-textPrimary text-lg font-poppinsRegular w-full md:w-[340px] lg:w-[371px]'>
                                Bank BPR Palu Anugerah terus mengembangkan layanannya, sehingga sudah memiliki beberapa cabang di sulawesi tengah yaitu poso, parigi ,luwuk, dan juga memiliki dua kantor kas yaitu kas tentena dan kas toili.
                            </p>
                        </div>
                    </motion.div>
                </div>

                <motion.div
                    className='mt-14'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 1 }}
                >
                    <Link to="/tentang-kami" className='font-poppinsRegular text-bprDarkBlue text-[14px] hover:text-bprBlue'>
                        CARI TAHU LEBIH BANYAK TENTANG BPR PALU ANUGERAH
                    </Link>
                </motion.div>
            </div>
        </div>
    );
}
